module.exports = __webpack_public_path__ + "img/w1-cover.70810c71.jpg";